import {CHNANGE_TAB} from "./actionTypes"

export const changeTab = (pageIndex) =>{
    return{
        type:CHNANGE_TAB,
        payload:pageIndex
    }
}